function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #009fe3;\n      }\n\n      .cls-2 {\n        font-family: OpenSans-Bold, 'Open Sans';\n        font-size: 400px;\n        font-weight: 700;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "m250,15c31.73,0,62.51,6.21,91.47,18.46,27.98,11.84,53.12,28.78,74.7,50.37,21.59,21.59,38.53,46.72,50.37,74.7,12.25,28.96,18.46,59.74,18.46,91.47s-6.21,62.51-18.46,91.47c-11.84,27.98-28.78,53.12-50.37,74.7s-46.72,38.53-74.7,50.37c-28.96,12.25-59.74,18.46-91.47,18.46s-62.51-6.21-91.47-18.46c-27.98-11.84-53.12-28.78-74.7-50.37-21.59-21.59-38.53-46.72-50.37-74.7-12.25-28.96-18.46-59.74-18.46-91.47s6.21-62.51,18.46-91.47c11.84-27.98,28.78-53.12,50.37-74.7,21.59-21.59,46.72-38.53,74.7-50.37,28.96-12.25,59.74-18.46,91.47-18.46m0-15C111.93,0,0,111.93,0,250s111.93,250,250,250,250-111.93,250-250S388.07,0,250,0h0Z"
});

var _ref4 = /*#__PURE__*/React.createElement("text", {
  className: "cls-2",
  transform: "translate(188.96 409.43)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "i"));

var SvgInfo = function SvgInfo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 500 526.62",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInfo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Info.efc1d596.svg";
export { ForwardRef as ReactComponent };